import { Directive, OnInit, inject, input } from '@angular/core';

import { injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsToast } from '@frontend/ui/toast';

import { ToastVariant } from './types';

@Directive({
    selector: '[msThemedToast]',
})
export class SportsThemedToastDirective implements OnInit {
    themedToastVariant = input<ToastVariant>();
    currentTheme = injectCurrentTheme();
    toast: DsToast = inject(DsToast, {
        self: true,
    });

    ngOnInit(): void {
        const variant = this.themedToastVariant()?.[this.currentTheme];
        if (variant) {
            this.toast.variant.set(variant);
        }
    }
}
